import { STORAGE_KEYS } from './constants'

/**
 * 本地存储工具类
 */
class Storage {
  /**
   * 设置localStorage
   * @param {string} key 键名
   * @param {any} value 值
   */
  setLocal(key, value) {
    try {
      const data = JSON.stringify(value)
      localStorage.setItem(key, data)
    } catch (error) {
      console.error('设置localStorage失败:', error)
    }
  }

  /**
   * 获取localStorage
   * @param {string} key 键名
   * @param {any} defaultValue 默认值
   * @returns {any} 存储的值
   */
  getLocal(key, defaultValue = null) {
    try {
      const data = localStorage.getItem(key)
      return data ? JSON.parse(data) : defaultValue
    } catch (error) {
      console.error('获取localStorage失败:', error)
      return defaultValue
    }
  }

  /**
   * 删除localStorage
   * @param {string} key 键名
   */
  removeLocal(key) {
    try {
      localStorage.removeItem(key)
    } catch (error) {
      console.error('删除localStorage失败:', error)
    }
  }

  /**
   * 清空localStorage
   */
  clearLocal() {
    try {
      localStorage.clear()
    } catch (error) {
      console.error('清空localStorage失败:', error)
    }
  }

  /**
   * 设置sessionStorage
   * @param {string} key 键名
   * @param {any} value 值
   */
  setSession(key, value) {
    try {
      const data = JSON.stringify(value)
      sessionStorage.setItem(key, data)
    } catch (error) {
      console.error('设置sessionStorage失败:', error)
    }
  }

  /**
   * 获取sessionStorage
   * @param {string} key 键名
   * @param {any} defaultValue 默认值
   * @returns {any} 存储的值
   */
  getSession(key, defaultValue = null) {
    try {
      const data = sessionStorage.getItem(key)
      return data ? JSON.parse(data) : defaultValue
    } catch (error) {
      console.error('获取sessionStorage失败:', error)
      return defaultValue
    }
  }

  /**
   * 删除sessionStorage
   * @param {string} key 键名
   */
  removeSession(key) {
    try {
      sessionStorage.removeItem(key)
    } catch (error) {
      console.error('删除sessionStorage失败:', error)
    }
  }

  /**
   * 清空sessionStorage
   */
  clearSession() {
    try {
      sessionStorage.clear()
    } catch (error) {
      console.error('清空sessionStorage失败:', error)
    }
  }

  // 便捷方法 - 用户信息
  setUserInfo(userInfo) {
    this.setLocal(STORAGE_KEYS.USER_INFO, userInfo)
  }

  getUserInfo() {
    return this.getLocal(STORAGE_KEYS.USER_INFO)
  }

  removeUserInfo() {
    this.removeLocal(STORAGE_KEYS.USER_INFO)
  }

  // 便捷方法 - Token
  setToken(token) {
    this.setLocal(STORAGE_KEYS.TOKEN, token)
  }

  getToken() {
    return this.getLocal(STORAGE_KEYS.TOKEN)
  }

  removeToken() {
    this.removeLocal(STORAGE_KEYS.TOKEN)
  }

  // 便捷方法 - 语言
  setLanguage(language) {
    this.setLocal(STORAGE_KEYS.LANGUAGE, language)
  }

  getLanguage() {
    return this.getLocal(STORAGE_KEYS.LANGUAGE)
  }

  // 便捷方法 - 主题
  setTheme(theme) {
    this.setLocal(STORAGE_KEYS.THEME, theme)
  }

  getTheme() {
    return this.getLocal(STORAGE_KEYS.THEME)
  }

  // 便捷方法 - 记住我
  setRememberMe(remember) {
    this.setLocal(STORAGE_KEYS.REMEMBER_ME, remember)
  }

  getRememberMe() {
    return this.getLocal(STORAGE_KEYS.REMEMBER_ME, false)
  }
}

// 创建实例并导出
const storage = new Storage()
export default storage

// 带过期时间的存储函数
/**
 * 设置带过期时间的存储
 * @param {string} key 键名
 * @param {any} value 值
 * @param {number} expireTime 过期时间（毫秒）
 */
export function setStorage(key, value, expireTime = null) {
  try {
    const data = {
      value: value,
      timestamp: Date.now(),
      expireTime: expireTime ? Date.now() + expireTime : null
    }
    localStorage.setItem(key, JSON.stringify(data))
  } catch (error) {
    console.error('设置存储失败:', error)
  }
}

/**
 * 获取带过期时间验证的存储
 * @param {string} key 键名
 * @param {any} defaultValue 默认值
 * @returns {any} 存储的值
 */
export function getStorage(key, defaultValue = null) {
  try {
    const data = localStorage.getItem(key)
    if (!data) return defaultValue
    
    const parsed = JSON.parse(data)
    
    // 检查是否过期
    if (parsed.expireTime && Date.now() > parsed.expireTime) {
      localStorage.removeItem(key)
      return defaultValue
    }
    
    return parsed.value
  } catch (error) {
    console.error('获取存储失败:', error)
    return defaultValue
  }
}

/**
 * 删除存储
 * @param {string} key 键名
 */
export function removeStorage(key) {
  try {
    localStorage.removeItem(key)
  } catch (error) {
    console.error('删除存储失败:', error)
  }
} 